import React from "react";
import { useMenu } from "../state";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoClose } from "react-icons/io5";

/* Menu Button
============================================================================= */

const MenuButton = () => {
	// Config
	const { open, setOpen } = useMenu();

	// Render
	return (
		<button
			onMouseDown={() => {
				if (!open) {
					setOpen(true);
				}
			}}
			className="flex items-center justify-center w-16 h-16 text-white md:h-20 md:w-20 bg-gtred"
		>
			{open ? (
				<IoClose fill="white" stroke="white" size={70} />
			) : (
				<GiHamburgerMenu color="white" size={50} />
			)}
		</button>
	);
};

/* Export
============================================================================= */

export default MenuButton;
